import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/modules/profiles/assets/illustrations/illustration-duplicate.svg'


const _withScopeId = n => (_pushScopeId("data-v-5122e3e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "duplicate",
  class: "header"
}, null, -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Duplicate", -1))
const _hoisted_4 = { class: "highlight" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " This action will duplicate all of the existing details of this profile however the name must be different ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Duplicate ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    onConfirm: _ctx.duplicateProfile,
    onClose: _ctx.close,
    disabled: _ctx.duplicateDisabled,
    "main-button-color": "var(--color-secondary)"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h2", null, [
          _createElementVNode("i", _hoisted_4, _toDisplayString(_ctx.selectedProfile.name), 1)
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileInput) = $event)),
          placeholder: "Choose a new profile name..."
        }, null, 512), [
          [_vModelText, _ctx.profileInput]
        ])
      ])
    ]),
    "button-content": _withCtx(() => [
      _hoisted_6
    ]),
    _: 1
  }, 8, ["onConfirm", "onClose", "disabled"]))
}